export enum CustomFieldTarget {
    Invoice = 'invoice',
    Quote = 'quote',
    Customer = 'customer',
    Purchase = 'purchase',
    Bank = 'bank',
    Reporter = 'reporter',
    Activity = 'activity'
}